// extracted by mini-css-extract-plugin
export var fullWidthButton = "_s6-0";